import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgHome = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M7.568 1.156a.676.676 0 0 1 .863 0l7.333 6.125c.28.235.317.648.078.924a.675.675 0 0 1-.939.077l-.683-.57v5.1c0 1.21-.995 2.188-2.222 2.188h-8c-1.227 0-2.222-.979-2.222-2.187v-5.1l-.68.569a.67.67 0 0 1-.939-.077.65.65 0 0 1 .078-.924zM3.11 6.6v6.213c0 .483.397.874.888.874h8a.88.88 0 0 0 .889-.874V6.6L7.998 2.518zm3.11.525c0-.464.188-.91.521-1.237a1.8 1.8 0 0 1 1.257-.513c.471 0 .924.184 1.257.513.333.328.52.773.52 1.237s-.187.91-.52 1.237a1.8 1.8 0 0 1-1.257.513c-.471 0-.924-.184-1.257-.513a1.74 1.74 0 0 1-.52-1.237m.89 2.625h1.777c1.227 0 2.222.979 2.222 2.188 0 .24-.2.437-.444.437H5.332a.44.44 0 0 1-.445-.437c0-1.21.995-2.188 2.222-2.188"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgHome);
export default ForwardRef;
